"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGiveawayRewards = void 0;
const useCreatorGiveaways_1 = require("root/src/client/web/giveaway/hooks/useCreatorGiveaways");
const useWindowSize_1 = __importDefault(require("root/src/client/web/hooks/useWindowSize"));
const styles_1 = require("@material-ui/styles");
const giveawayRewardsSliderBreakpoints_1 = require("root/src/client/web/giveaway/helpers/giveawayRewardsSliderBreakpoints");
// it's used because we have to override some styles from Slider
const useSliderStyles = (0, styles_1.makeStyles)({
    sliderItems: {
        alignItems: 'initial !important',
        gap: 8,
    },
});
const useGiveawayRewards = () => {
    const rewards = (0, useCreatorGiveaways_1.useCreatorRewards)();
    const classes = useSliderStyles();
    const [width] = (0, useWindowSize_1.default)();
    const sliderBreakpoints = (0, giveawayRewardsSliderBreakpoints_1.getSliderBreakpoints)(width || 0);
    return {
        rewards,
        sliderBreakpoints,
        classes,
    };
};
exports.useGiveawayRewards = useGiveawayRewards;
